/**
 * Fixed-work JS micro-benchmark, timed once per resource sample.
 *
 * The per-widget commit cost in an export can't by itself distinguish "the app
 * is doing 100× more work" from "every line of JS in this tab runs 100× slower"
 * (DevTools attached, an extension instrumenting the page, GC thrash on a
 * multi-GB heap, a throttled renderer). This runs the same deterministic loop
 * every sample, so a slow tab shows up as a probe that's tens of ms instead of
 * ~1 ms, independent of what the app itself is rendering.
 */
export const CPU_PROBE_ITERATIONS = 200_000

// Written every run so the loop's result is observable and can't be
// dead-code eliminated.
let probeSink = 0
export function __cpuProbeSink(): number {
  return probeSink
}

export function runCpuProbe(now: () => number = () => performance.now()): number {
  const start = now()
  // xorshift32 over a fixed seed: integer-only and allocation-free, so the
  // number measures raw JS throughput rather than the allocator.
  let x = 0x9e3779b9
  let acc = 0
  for (let i = 0; i < CPU_PROBE_ITERATIONS; i++) {
    x ^= x << 13
    x ^= x >>> 17
    x ^= x << 5
    acc = (acc + (x & 0xff)) | 0
  }
  const elapsed = now() - start
  probeSink = acc
  return Math.round(elapsed * 100) / 100
}
